var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
import { Form, Grid } from "semantic-ui-react";
import ErrorDisplay from "../../ErrorDisplay";
import FieldWithErrorDisplay from "../../FieldWithErrorDisplay";
import { postJsonWithAuthn } from "../../RequestHelpers";
import { discountMessage, priceColumn, PriceDisplay, ToggleableKitComponent } from "../rna-fish/EditKitForm";
import { ErrorElementsWithPrices } from "../rna-fish/NewRnaFishKitPage";
import AutomatedIfDetectForm from "./AutomatedIfDetectForm";
import AutomatedIfEncoderForm from "./AutomatedIfEncoderForm";
var EditKitForm = /** @class */ (function (_super) {
    __extends(EditKitForm, _super);
    function EditKitForm() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onSampleTypeChange = function (_, data) {
            var sampleType = _this.props.catalog.automatedGoldIfSampleTypes.find(function (t) { return t.id === data.value; });
            if (!sampleType) {
                return;
            }
            _this.props.setFormState(function () { return ({ sampleTypeFormState: { sampleType: sampleType } }); }, _this.onUserSelection);
        };
        _this.onPlatformChange = function (_, data) {
            var newPlatformId = data.value;
            var catalog = _this.props.catalog;
            _this.props.setFormState(function (oldState) {
                var currentScale = catalog.automatedIfPresetScales.find(function (s) { return s.id === oldState.selectedPresetScaleId; });
                var matchingScale = currentScale
                    ? catalog.automatedIfPresetScales.find(function (s) { return s.platform.id === newPlatformId && s.units === currentScale.units; })
                    : undefined;
                if (matchingScale) {
                    return {
                        platformId: newPlatformId,
                        selectedPresetScaleId: matchingScale.id,
                        encoderComponentState: __assign(__assign({}, oldState.encoderComponentState), { encoderScaleUl: matchingScale.encoderScaleUl, antibodyBlockMl: matchingScale.antibodyBlockMl, antibodyDiluentMl: matchingScale.antibodyDiluentMl }),
                        detectComponentState: __assign(__assign({}, oldState.detectComponentState), { detectAMl: matchingScale.detectAMl, detectBMl: matchingScale.detectBMl, detectCMl: matchingScale.detectCMl })
                    };
                }
                return {
                    platformId: newPlatformId,
                    selectedPresetScaleId: undefined,
                    encoderComponentState: __assign(__assign({}, oldState.encoderComponentState), { encoderScaleUl: 0, antibodyBlockMl: 0, antibodyDiluentMl: 0 }),
                    detectComponentState: __assign(__assign({}, oldState.detectComponentState), { detectAMl: 0, detectBMl: 0, detectCMl: 0 })
                };
            }, _this.onUserSelection);
        };
        _this.onPresetScaleChange = function (_, data) {
            var scaleId = data.value;
            if (!scaleId) {
                _this.props.setFormState(function (s) { return ({
                    selectedPresetScaleId: undefined,
                    // zero out the scales if we cleared the preset scale
                    encoderComponentState: __assign(__assign({}, s.encoderComponentState), { encoderScaleUl: 0, antibodyBlockMl: 0, antibodyDiluentMl: 0 }),
                    detectComponentState: __assign(__assign({}, s.detectComponentState), { detectAMl: 0, detectBMl: 0, detectCMl: 0 })
                }); });
                return;
            }
            var scale = _this.props.catalog.automatedIfPresetScales.find(function (s) { return s.id === scaleId; });
            if (!scale) {
                return;
            }
            _this.props.setFormState(function (s) { return ({
                selectedPresetScaleId: scale.id,
                encoderComponentState: __assign(__assign({}, s.encoderComponentState), { encoderScaleUl: scale.encoderScaleUl, antibodyBlockMl: scale.antibodyBlockMl, antibodyDiluentMl: scale.antibodyDiluentMl }),
                detectComponentState: __assign(__assign({}, s.detectComponentState), { detectAMl: scale.detectAMl, detectBMl: scale.detectBMl, detectCMl: scale.detectCMl })
            }); }, _this.onUserSelection);
        };
        _this.onPlexityChange = function (_, data) {
            var _a;
            var config = (_a = _this.props.catalog.automatedIfDetect.configs
                .find(function (c) { return c.plexity === data.value; })) !== null && _a !== void 0 ? _a : _this.props.catalog.automatedIfDetect.configs[0];
            if (config === undefined) {
                throw new RangeError("Could not find config " + data.value);
            }
            var catalog = _this.props.catalog;
            _this.props.setFormState(function (oldState) {
                var currentScale = catalog.automatedIfPresetScales.find(function (s) { return s.id === oldState.selectedPresetScaleId; });
                var matchingScale = catalog.automatedIfPresetScales.find(function (s) { return s.active && s.platform.id === oldState.platformId
                    && (!currentScale || s.units === currentScale.units); });
                if (matchingScale) {
                    return {
                        plexity: config.plexity,
                        selectedPresetScaleId: matchingScale.id,
                        encoderComponentState: __assign(__assign({}, oldState.encoderComponentState), { encoderScaleUl: matchingScale.encoderScaleUl, antibodyBlockMl: matchingScale.antibodyBlockMl, antibodyDiluentMl: matchingScale.antibodyDiluentMl }),
                        detectComponentState: __assign(__assign({}, oldState.detectComponentState), { snapCooledConfigId: config.id, detectAMl: matchingScale.detectAMl, detectBMl: matchingScale.detectBMl, detectCMl: matchingScale.detectCMl })
                    };
                }
                return {
                    plexity: config.plexity,
                    selectedPresetScaleId: undefined,
                    encoderComponentState: __assign(__assign({}, oldState.encoderComponentState), { encoderScaleUl: 0, antibodyBlockMl: 0, antibodyDiluentMl: 0 }),
                    detectComponentState: __assign(__assign({}, oldState.detectComponentState), { snapCooledConfigId: config.id, detectAMl: 0, detectBMl: 0, detectCMl: 0 })
                };
            }, _this.onUserSelection);
        };
        _this.onEncoderEnabledChange = function () {
            return _this.props.setFormState(function (s) {
                var turningOn = !s.encoderEnabled;
                var scale = turningOn
                    ? _this.props.catalog.automatedIfPresetScales.find(function (ps) { return ps.id === s.selectedPresetScaleId; })
                    : undefined;
                return __assign({ encoderEnabled: turningOn }, (scale && {
                    encoderComponentState: __assign(__assign({}, s.encoderComponentState), { encoderScaleUl: scale.encoderScaleUl, antibodyBlockMl: scale.antibodyBlockMl, antibodyDiluentMl: scale.antibodyDiluentMl })
                }));
            }, _this.onUserSelection);
        };
        _this.onDetectEnabledChange = function () {
            return _this.props.setFormState(function (s) {
                var turningOn = !s.detectEnabled;
                var scale = turningOn
                    ? _this.props.catalog.automatedIfPresetScales.find(function (ps) { return ps.id === s.selectedPresetScaleId; })
                    : undefined;
                return __assign({ detectEnabled: turningOn }, (scale && {
                    detectComponentState: __assign(__assign({}, s.detectComponentState), { detectAMl: scale.detectAMl, detectBMl: scale.detectBMl, detectCMl: scale.detectCMl })
                }));
            }, _this.onUserSelection);
        };
        _this.onAmpConfigChange = function (pairs, snapCooledConfigId) {
            _this.props.setFormState(function (s) { return ({
                detectComponentState: __assign(__assign({}, s.detectComponentState), { snapCooledConfigId: snapCooledConfigId, customAmpLabelPairs: pairs })
            }); }, _this.onUserSelection);
        };
        _this.onEncoderChange = function (updater, callback) {
            _this.props.setFormState(function (oldState) { return ({
                encoderComponentState: Object.assign({}, oldState.encoderComponentState, updater(oldState.encoderComponentState))
            }); }, callback);
        };
        _this.onDetectChange = function (updater, callback) {
            _this.props.setFormState(function (oldState) { return ({
                detectComponentState: Object.assign({}, oldState.detectComponentState, updater(oldState.detectComponentState))
            }); }, callback);
        };
        _this.onCommentChange = function (event) {
            var str = event.currentTarget.value;
            _this.props.setFormState(function () { return ({ comment: str }); });
        };
        _this.onUserSelection = function () {
            _this.loadPrice();
        };
        _this.loadPrice = function () {
            _this.props.setFormState(function () { return ({ priceLoading: true }); }, function (newState) {
                postJsonWithAuthn(_this.props.kitPriceUrlPath, JSON.stringify(serializeAutomatedIfKit(newState, _this.props.catalog)))
                    .then(function (resp) {
                    if (resp.status === 400) {
                        return resp.json().then(function (json) {
                            return new ErrorElementsWithPrices(json.errors, json.price);
                        });
                    }
                    return resp.json();
                })
                    .then(function (resp) {
                    if (resp instanceof ErrorElementsWithPrices) {
                        _this.props.setFormState(function () { return ({
                            errors: resp.errors,
                            priceLoading: false,
                            price: resp.price
                        }); });
                    }
                    else {
                        _this.props.setFormState(function () { return ({
                            errors: [],
                            price: resp,
                            priceLoading: false
                        }); });
                    }
                })
                    .catch(function (rej) {
                    console.error("Couldn't update price: " + rej);
                });
            });
        };
        return _this;
    }
    EditKitForm.prototype.componentDidMount = function () {
        if (this.props.loadPriceOnMount) {
            this.loadPrice();
        }
    };
    EditKitForm.prototype.render = function () {
        var _a = this.props, formState = _a.formState, catalog = _a.catalog, showErrors = _a.showErrors, enableCustomPrice = _a.enableCustomPrice;
        var plexityOptions = catalog.automatedIfDetect.configs
            .map(function (c) { return ({
            text: c.plexity + "-plex",
            value: c.plexity
        }); });
        var platformOptions = catalog.automatedIfPlatforms.map(function (p) { return ({
            text: p.alias,
            value: p.id
        }); });
        var platformPresetScales = catalog.automatedIfPresetScales.filter(function (s) { return s.platform.id === formState.platformId &&
            s.active; });
        var presetScaleOptions = platformPresetScales
            .map(function (s) { return ({
            text: s.units + " " + s.unitsLabel,
            value: s.id
        }); });
        var currentAmpLabelPairs = (function () {
            var _a, _b, _c, _d, _e;
            var detectState = formState.detectComponentState;
            if (detectState.snapCooledConfigId === -1) {
                return (_a = detectState.customAmpLabelPairs) !== null && _a !== void 0 ? _a : [];
            }
            return (_e = (_c = (_b = catalog.automatedIfDetect.configs.find(function (c) { return c.id === detectState.snapCooledConfigId; })) === null || _b === void 0 ? void 0 : _b.channels) !== null && _c !== void 0 ? _c : (_d = catalog.automatedIfDetect.configs.find(function (c) { return c.plexity === formState.plexity; })) === null || _d === void 0 ? void 0 : _d.channels) !== null && _e !== void 0 ? _e : [];
        })();
        return React.createElement("div", { className: 'kit-form' },
            React.createElement(ErrorDisplay, { errors: formState.errors, errorPath: '/' }),
            React.createElement("div", null),
            React.createElement(FieldWithErrorDisplay, { labelContent: 'Sample Type', labelFor: 'sampleType', errors: formState.errors, errorPath: '/sampleTypeId', showErrors: showErrors },
                React.createElement(Form.Select, { name: 'sampleType', options: catalog.automatedGoldIfSampleTypes.map(function (t) { return ({ text: t.label, value: t.id }); }), value: formState.sampleTypeFormState.sampleType.id, onChange: this.onSampleTypeChange })),
            React.createElement(FieldWithErrorDisplay, { labelContent: 'Platform', labelFor: 'platform', errors: formState.errors, errorPath: '/platformId', showErrors: showErrors },
                React.createElement(Form.Select, { name: 'platform', options: platformOptions, value: formState.platformId, onChange: this.onPlatformChange })),
            presetScaleOptions.length > 0 && (React.createElement(FieldWithErrorDisplay, { labelContent: 'Slides', labelFor: 'presetScale', errors: formState.errors, errorPath: '/presetScale', showErrors: showErrors },
                React.createElement(Form.Select, { name: 'presetScale', placeholder: 'Select slides...', options: presetScaleOptions, value: formState.selectedPresetScaleId, onChange: this.onPresetScaleChange, clearable: true }))),
            React.createElement(FieldWithErrorDisplay, { labelContent: 'Plexity', labelFor: 'plexity', errors: formState.errors, errorPath: '/plexity', showErrors: showErrors },
                React.createElement(Form.Select, { name: 'plexity', options: plexityOptions, value: formState.plexity, onChange: this.onPlexityChange })),
            React.createElement(ToggleableKitComponent, { componentEnabled: formState.encoderEnabled, label: 'HCR™ HiFi Encoder', otherComponentStates: [formState.detectEnabled], onChange: this.onEncoderEnabledChange, cish: false },
                React.createElement(AutomatedIfEncoderForm, { catalog: catalog, plexity: formState.plexity, encoderState: formState.encoderComponentState, onEncoderChange: this.onEncoderChange, errors: formState.errors, showErrors: showErrors, enableCustomPrice: enableCustomPrice, effectivePriceCents: formState.price ? formState.price.effectivePrice.encoderPriceCents : undefined, listPriceCents: formState.price ? formState.price.listPrice.encoderPriceCents : undefined, priceLoading: formState.priceLoading, onUserSelection: this.onUserSelection, scalesReadOnly: !!formState.selectedPresetScaleId, ampConfigEditable: !formState.detectEnabled, currentAmpLabelPairs: currentAmpLabelPairs, onAmpConfigChange: this.onAmpConfigChange })),
            React.createElement(ToggleableKitComponent, { componentEnabled: formState.detectEnabled, label: 'HCR™ Automated Detect', otherComponentStates: [formState.encoderEnabled], onChange: this.onDetectEnabledChange, cish: false },
                React.createElement(AutomatedIfDetectForm, { detectCatalog: catalog.automatedIfDetect, availableAmplifiers: catalog.automatedIfCustomAmplifiers, availableFluorophores: catalog.automatedIfCustomFluorophores, plexity: formState.plexity, detectState: formState.detectComponentState, onDetectChange: this.onDetectChange, errors: formState.errors, showErrors: showErrors, enableCustomPrice: enableCustomPrice, effectivePriceCents: formState.price ? formState.price.effectivePrice.detectPriceCents : undefined, listPriceCents: formState.price ? formState.price.listPrice.detectPriceCents : undefined, priceLoading: formState.priceLoading, onUserSelection: this.onUserSelection, scalesReadOnly: !!formState.selectedPresetScaleId })),
            React.createElement(ErrorDisplay, { errors: formState.errors, errorPath: '/' }),
            React.createElement(Grid, { columns: 4, stackable: true },
                React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, { width: 12, className: 'no-left-padding-mobile' },
                        React.createElement(Form.Field, null,
                            React.createElement("label", { htmlFor: 'comment' }, "Comment"),
                            React.createElement(Form.TextArea, { style: { fontFamily: 'Avenir Next' }, placeholder: 'Please describe any instructions for order fulfillment or anything else the MI Team should be aware of regarding this order.', value: formState.comment, onChange: this.onCommentChange }))),
                    priceColumn(React.createElement("div", { style: { 'paddingRight': '.5rem' } },
                        React.createElement(PriceDisplay, { loading: formState.priceLoading, priceCents: formState.price ? formState.price.effectivePrice.subtotalCents : undefined })))),
                React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, { width: 16 }, formState.price && discountMessage(formState.price.discountCents, formState.price.listPrice.subtotalCents)))));
    };
    return EditKitForm;
}(React.PureComponent));
export { EditKitForm };
export var defaultEncoderComponentState = function (plexity) { return ({
    primarySpeciesIds: [],
    encoderScaleUl: 0,
    antibodyBlockMl: 0,
    antibodyDiluentMl: 0
}); };
export var defaultDetectComponentState = function (snapCooledConfigId, customAmpLabelPairs) { return ({
    snapCooledConfigId: snapCooledConfigId,
    customAmpLabelPairs: customAmpLabelPairs,
    detectAMl: 0,
    detectBMl: 0,
    detectCMl: 0
}); };
export var defaultAutomatedIfFormState = function (catalog) {
    var _a, _b;
    // 3 plex should be the default config
    var defaultConfig = catalog.automatedIfDetect.configs[2];
    return {
        plexity: defaultConfig.plexity,
        sampleTypeFormState: { sampleType: catalog.automatedGoldIfSampleTypes[0] },
        platformId: (_b = (_a = catalog.automatedIfPlatforms[0]) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : '',
        encoderEnabled: true,
        detectEnabled: true,
        encoderComponentState: defaultEncoderComponentState(defaultConfig.plexity),
        detectComponentState: defaultDetectComponentState(defaultConfig.id),
        comment: '',
        errors: [],
        priceLoading: false
    };
};
var serializePriceMode = function (customPrice) {
    return customPrice
        ? { _type: 'custom', effectivePriceCents: customPrice.effectivePriceCents, listPriceCents: customPrice.listPriceCents }
        : { _type: 'priceList' };
};
export var serializeAutomatedIfKit = function (state, catalog) {
    var _a, _b, _c, _d;
    var config = state.detectComponentState.snapCooledConfigId === -1
        ? undefined
        : ((_a = catalog.automatedIfDetect.configs.find(function (c) { return c.id === state.detectComponentState.snapCooledConfigId; })) !== null && _a !== void 0 ? _a : catalog.automatedIfDetect.configs.find(function (c) { return c.plexity === state.plexity; }));
    var channels = state.detectComponentState.snapCooledConfigId === -1
        ? ((_b = state.detectComponentState.customAmpLabelPairs) !== null && _b !== void 0 ? _b : [])
        : ((_c = config === null || config === void 0 ? void 0 : config.channels) !== null && _c !== void 0 ? _c : []);
    var encoderComponent = state.encoderEnabled && channels.length > 0 ? {
        encoderAmpPairs: state.encoderComponentState.primarySpeciesIds.slice(0, channels.length).map(function (speciesId, i) { return ({
            primarySpeciesId: speciesId,
            hcrAmplifierId: channels[i].hcrAmplifier.id,
            channel: channels[i].channel
        }); }),
        encoderScaleUl: state.encoderComponentState.encoderScaleUl,
        antibodyBlockMl: state.encoderComponentState.antibodyBlockMl,
        antibodyDiluentMl: state.encoderComponentState.antibodyDiluentMl,
    } : undefined;
    var detectComponent = state.detectEnabled && channels.length > 0 ? {
        ampLabelPairs: channels.map(function (ch) { return ({
            hcrAmplifierId: ch.hcrAmplifier.id,
            fluorophoreId: ch.fluorophore.id,
            channel: ch.channel
        }); }),
        detectAMl: state.detectComponentState.detectAMl,
        detectBMl: state.detectComponentState.detectBMl,
        detectCMl: state.detectComponentState.detectCMl,
    } : undefined;
    var kit = {
        plexity: state.plexity,
        sampleTypeId: state.sampleTypeFormState.sampleType.id,
        platformId: state.platformId,
        presetScaleId: (_d = state.selectedPresetScaleId) !== null && _d !== void 0 ? _d : null,
        encoderComponent: encoderComponent,
        detectComponent: detectComponent,
        comment: state.comment,
        starterKit: false,
        priceModes: {
            encoderMode: serializePriceMode(state.encoderComponentState.customPrice),
            detectMode: serializePriceMode(state.detectComponentState.customPrice)
        }
    };
    return { '_type': 'automated-gold-if', kit: kit };
};
//# sourceMappingURL=EditKitForm.js.map


//////////////////
// WEBPACK FOOTER
// ../common/build/dist/kit/automated-gold-if/EditKitForm.js
// module id = 324
// module chunks = 0